module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<h5 class="sans"><i class="fa fa-inbox me-1" aria-hidden="true"></i>'+
((__t=( description ))==null?'':__t)+
'</h5> <dl class="event-bill-list ms-2"></dl>\n';
}
return __p;
};
